import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getViewAndUpdatePaymentMethodsCTA } from "./shared";

export const ChangeDefaultPaymentMethodIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return CHANGE_DEFAULT_PAYMENT_METHOD(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)
          ?.label;
      },
      linkBuilder: (context) => {
        return getViewAndUpdatePaymentMethodsCTA(
          context,
          strictLocalize
        )?.getLink?.();
      },
    },
  };
};

const CHANGE_DEFAULT_PAYMENT_METHOD = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Change default payment method",
    description: {
      text: "Title for the answer about how to change the default payment method",
    },
  });

const CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can change the default payment method by clicking the button below. The payment method marked as default at the time your invoice comes due is the one that will be charged. If your default payment method fails, your alternate payment method on file may be charged.",
    description: {
      text: "Description for the answer about how to change the default payment method",
    },
  });
